import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { civilPath } from '../constants';
import { useStore } from '../store';
import { Button } from 'antd';
import MenuFoldOutlined from '@ant-design/icons/lib/icons/MenuFoldOutlined';
import MenuUnfoldOutlined from '@ant-design/icons/lib/icons/MenuUnfoldOutlined';
import MenuOutlined from '@ant-design/icons/lib/icons/MenuOutlined';
import PageLayout from '../layout';
import CourseOverview from './components/CourseOverview/index';
import { LeftMenu } from './components/LeftMenu';
import { Cybersecurity2025 } from './cybersecurity2025';
import NextTopicIcon from '@/assets/2025/arrow_next.png';
import './index.less';
import './index.mobile.less';
interface CyberSecurityProps {}
const CyberSecurity: React.FunctionComponent<CyberSecurityProps> = (props) => {
  const param = useParams();
  const navigate = useNavigate();
  const [sideCollapsed, setSideCollapsed] = React.useState(
    window.innerWidth <= 1024
  );
  const getSystemFontScale = () => {
    const testEl = document.createElement('div');
    testEl.style.cssText =
      'font-size:100px!important;position:absolute;visibility:hidden;width:0;height:0;overflow:hidden;';
    document.body.appendChild(testEl);
    const scaledSize = parseFloat(window.getComputedStyle(testEl).fontSize);
    document.body.removeChild(testEl);
    return scaledSize / 100;
  };

  const getfontSize = () => {
    let docEl = document.documentElement,
      clientWidth = docEl.clientWidth;
    if (!clientWidth) {
      return;
    }

    let targetFontSize;
    if (clientWidth <= 1024) {
      targetFontSize = Math.min(Math.max((clientWidth / 375) * 8, 6), 10);
    } else {
      clientWidth = clientWidth >= 1980 ? 1980 : clientWidth;
      targetFontSize = 16 * (clientWidth / 1920);
    }

    const fontScale = getSystemFontScale();
    const correctedFontSize =
      fontScale !== 1 ? targetFontSize / fontScale : targetFontSize;
    docEl.style.fontSize = `${correctedFontSize}px`;
  };
  React.useEffect(() => {
    getfontSize();
    window.addEventListener('resize', getfontSize);
    return () => {
      document.documentElement.style.fontSize = '';
      window.removeEventListener('resize', getfontSize);
    };
  }, []);
  const p_course = param.course;
  const p_topic = param['*'] || 'welcome';
  const {
    initPageSettings,
    getCourseState,
    setCourseState,
    courses,
    page,
    language,
    courseState: allCourseStates,
  } = useStore();

  // 初始化页面设置
  React.useEffect(() => {
    initPageSettings();
  }, [initPageSettings]);

  // 确保 courseState 被初始化（在 useEffect 中调用，不会触发渲染警告）
  React.useEffect(() => {
    if (courses && p_course) {
      const existingState = allCourseStates?.find((itm) => itm.id === p_course);
      if (!existingState) {
        // 只在不存在时初始化，避免重复调用
        getCourseState(p_course);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courses, p_course]); // 不包含 allCourseStates 和 getCourseState，避免循环

  // 直接从 store 中读取 courseState，避免在渲染期间调用可能触发 setState 的函数
  const courseState = React.useMemo(() => {
    if (!allCourseStates || !p_course) {
      return null;
    }
    return allCourseStates.find((itm) => itm.id === p_course) || null;
  }, [allCourseStates, p_course]);

  if (!page || !courses || !p_course || !courseState) {
    return <div>Loading</div>;
  }

  const course = courses[p_course];
  const { title: courseTitle, steps, nextLabel, topics } = course;
  const currentTopic = topics.find((itm: { id: string }) => itm.id === p_topic);
  const progress = courseState.progress;
  const currentStep = courseState.step;
  const nextTopic = topics.find(
    (itm: { id: string }) => itm.id === currentTopic.next
  );
  const currentTopicStates = courseState.topicStates.find(
    (t) => t.id === p_topic
  );
  const currentParagraphState = currentTopicStates?.paragraphStates;
  // console.log('currentTopicState====>>>>', currentTopicStates);
  const gotoNextTopic = () => {
    const currentTopicIndex = topics.findIndex(
      (itm: { id: string }) => itm.id === p_topic
    );
    const step = Math.floor(100 / courseState.topicStates.length);
    setCourseState(p_course, {
      ...courseState,
      progress:
        courseState.step === courseState.topicStates.length - 1
          ? 100
          : currentTopicIndex * step === courseState.progress
          ? Number(courseState.progress) + step
          : courseState.progress,
      step:
        currentTopicIndex === courseState.step
          ? courseState.step + 1
          : courseState.step,
    });
    document?.querySelector('.course-body')?.scrollTo({
      top: 0,
      left: 0,
    });
    navigate(civilPath(language, 'civil', p_course, currentTopic.next));
  };
  const toggleSide = () => {
    setSideCollapsed(!sideCollapsed);
  };
  if (
    !page?.landing?.courseSections?.some(
      (itm: any) => !itm.hide && itm.page === p_course
    )
  ) {
    location.href = `/#${civilPath(language)}`;
    return <div className="pagenotfound">404 Page Not found</div>;
  }
  return (
    <PageLayout pageName="course-page" pageClass={p_course}>
      <div
        className={`course-left-side ${sideCollapsed ? 'side-collapsed' : ''}`}
      >
        <MenuOutlined
          className="mobile-view toggle-menu-icon"
          onClick={toggleSide}
        />
        <Button
          className={`side-collapse-button ${
            sideCollapsed ? 'side-collapsed' : ''
          }`}
          type="text"
          onClick={toggleSide}
        >
          {sideCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
        <CourseOverview
          progress={progress}
          steps={steps}
          courseName={courseTitle}
          topicName={currentTopic.name}
          currentStep={currentStep}
        />
        <LeftMenu steps={steps} currentStep={currentStep} topics={topics} />
      </div>
      <div className={`course-body ${sideCollapsed ? 'side-collapsed' : ''}`}>
        {p_course === 'general-staff' && (
          <Cybersecurity2025 topicName={p_topic} topicSettings={currentTopic} />
        )}
        {nextTopic &&
          !currentParagraphState?.some((itm) => itm.state !== 'completed') && (
            <div className={`nextTopic_box ${p_course}`}>
              <Button
                className="next-topic-button"
                type="text"
                key={nextTopic.title}
                onClick={gotoNextTopic}
              >
                <img className="img" src={NextTopicIcon} alt="" />
                <div className="l1">{nextLabel}</div>
                <div className="l2">{nextTopic.title}</div>
              </Button>
            </div>
          )}
      </div>
    </PageLayout>
  );
};

export default CyberSecurity;
